export default __webpack_public_path__ + "static/media/aktion.9c566d03.svg";